import type { ExperienceAtfCardConfig, ExperienceAtfPromoVariant } from '~/features/experience/constants';
import {
  type BackToSchool2026SaleVariant,
  BTS_2026_SALE_VARIANTS,
  getBts2026SaleCtaHref,
} from '~/features/promotions/constants/back-to-school-2026-sale';

const BTS_2026_SALE_ATF_PROMO_VARIANT: Record<BackToSchool2026SaleVariant, ExperienceAtfPromoVariant> = {
  g1: 'bts_2026_g1',
  g2: 'bts_2026_g2',
};

/**
 * `/experience` ATF card for the sale (Figma 1856:2179 G1, 1856:2201 G2). No `eyebrow`: this design
 * leads with the accented headline instead of an "Ends soon" row. Kept out of `surfaces.tsx` so the
 * card contract stays unit-testable without pulling in the JSX surfaces.
 */
export function buildBackToSchool2026ExperienceCard(
  resolved: BackToSchool2026SaleVariant,
  promoCode?: string | null
): ExperienceAtfCardConfig {
  const config = BTS_2026_SALE_VARIANTS[resolved];
  const promoVariant = BTS_2026_SALE_ATF_PROMO_VARIANT[resolved];

  return {
    id: promoVariant,
    promoVariant,
    title: config.headlineLine1,
    titleLine2: config.headlineLine2,
    description: config.experienceAtfDescription,
    ctaLabel: config.experienceAtfCtaLabel,
    action: {
      type: 'link',
      href: getBts2026SaleCtaHref(promoCode),
    },
  };
}
